import {configureStore} from "@reduxjs/toolkit";
import {ControllerSlice, ContentSlice} from "../reducers";


const store = configureStore({
    reducer: {
        controller: ControllerSlice.reducer,
        content: ContentSlice.reducer
    },
})

export type RootState = ReturnType<typeof store.getState>

export const selectController = (state: RootState) => state.controller.dataChart;

export default store;
